import { Mo, Bd } from './shared';
import { GOLD, EMBER, MONO } from '../lib/constants';

/* ── Constants ── */
export const CATEGORY_LABELS = {
  // Personal Discretionary
  FOOD_AND_DRINK: 'Food & Drink', DINING_OUT: 'Dining Out', ENTERTAINMENT: 'Entertainment', 
  SHOPPING: 'Shopping', PERSONAL_CARE: 'Personal Care', GENERAL_MERCHANDISE: 'Shopping',
  TRAVEL: 'Travel', RECREATION: 'Recreation', FITNESS: 'Fitness', COFFEE_SHOPS: 'Coffee Shops',
  ALCOHOL_TOBACCO: 'Alcohol & Tobacco', PET_CARE: 'Pet Care', BEAUTY_SALON: 'Beauty & Salon',
  // Personal Essential
  GROCERIES: 'Groceries', RENT_AND_UTILITIES: 'Rent & Bills', HOUSING: 'Housing',
  TRANSPORTATION: 'Transportation', GAS_FUEL: 'Gas & Fuel', MEDICAL: 'Medical',
  HEALTHCARE: 'Healthcare', CHILDCARE: 'Childcare', EDUCATION: 'Education',
  GOVERNMENT_AND_NON_PROFIT: 'Gov & Tax', GENERAL_SERVICES: 'Services',
  HOME_IMPROVEMENT: 'Home Improvement', HOME_MAINTENANCE: 'Home Maintenance',
  PARKING_TOLLS: 'Parking & Tolls', TUITION: 'Tuition',
  // Personal Fixed
  PHONE_SERVICE: 'Phone Service', INTERNET: 'Internet', SUBSCRIPTIONS: 'Subscriptions',
  PERSONAL_INSURANCE: 'Insurance', CAR_INSURANCE: 'Car Insurance',
  HEALTH_INSURANCE: 'Health Insurance', LIFE_INSURANCE: 'Life Insurance',
  STORAGE_UNIT: 'Storage Unit',
  // Debt Payments
  LOAN_DEBT_PAYMENT: 'Loan / Debt Payment', CREDIT_CARD_PAYMENT: 'Credit Card Payment',
  AUTO_LOAN_PAYMENT: 'Auto Loan Payment', MORTGAGE_PAYMENT: 'Mortgage Payment',
  STUDENT_LOAN_PAYMENT: 'Student Loan Payment', PERSONAL_LOAN_PAYMENT: 'Personal Loan Payment',
  MEDICAL_DEBT_PAYMENT: 'Medical Debt Payment', BNPL_PAYMENT: 'Buy Now Pay Later',
  MCA_REPAYMENT: 'MCA Repayment', COLLECTIONS_PAYMENT: 'Collections Payment',
  // Business
  COST_OF_GOODS: 'Cost of Goods', PAYROLL_WAGES: 'Payroll & Wages',
  BUSINESS_TAXES: 'Business Taxes', BUSINESS_INSURANCE: 'Business Insurance',
  BUSINESS_RENT: 'Business Rent', BUSINESS_UTILITIES: 'Business Utilities',
  ADVERTISING_MARKETING: 'Advertising & Marketing', MERCHANT_FEES: 'Merchant Fees',
  BUSINESS_SUBSCRIPTIONS: 'Business Software', PAYROLL_CONTRACTORS: 'Payroll & Contractors',
  PROFESSIONAL_SERVICES: 'Professional Services', SUPPLIES_EQUIPMENT: 'Supplies & Equipment',
  // Other
  TRANSFER: 'Transfer', BANK_FEES: 'Bank Fees', INVESTMENTS: 'Investments',
  VEHICLE_AUTO: 'Vehicle / Auto', INSURANCE: 'Insurance', OTHER: 'Other',
  UNCATEGORIZED: 'Uncategorized', REFUND_RETURN: 'Refund / Return',
};
export const GRADE_COLORS = { A: '#22c55e', B: '#84cc16', C: '#eab308', D: '#f97316', F: '#ef4444' };
export const TREND_COLORS = { up: '#ef4444', down: '#22c55e', flat: 'var(--mute)' };
export const TREND_ARROWS = { up: '\u2191', down: '\u2193', flat: '\u2192' };
export const CAT_ICONS = {
  FOOD_AND_DRINK: 'F', ENTERTAINMENT: 'E', SHOPPING: 'S',
  TRANSPORTATION: 'T', RENT_AND_UTILITIES: 'R', PERSONAL_CARE: 'P',
  GENERAL_MERCHANDISE: 'M', TRAVEL: 'Tr', MEDICAL: 'Med',
  OTHER: 'O', GENERAL_SERVICES: 'Sv', GOVERNMENT_AND_NON_PROFIT: 'G',
  HOME_IMPROVEMENT: 'H', BANK_FEES: 'B', RECREATION: 'Rec',
  // Manual reclassification categories
  LOAN_DEBT_PAYMENT: '💳', VEHICLE_AUTO: '🚗', INSURANCE: '🛡️',
  INVESTMENTS: '📈', BUSINESS_TAXES: '🧾', PAYROLL_CONTRACTORS: '👥',
};

/* ── Helpers ── */
export const fmtDate = (d) => {
  const dt = new Date(d);
  return `${String(dt.getMonth()+1).padStart(2,'0')}/${String(dt.getDate()).padStart(2,'0')}/${dt.getFullYear()}`;
};

/* ── Shared Components ── */
export const Card = ({ children, style, testId }) => (
  <div data-testid={testId} className="dettio-card" style={style}>{children}</div>
);
export const SL = ({ children }) => (
  <Mo style={{ fontSize: 10, color: 'var(--mute)', letterSpacing: 1.5, display: 'block', marginBottom: 12 }}>{children}</Mo>
);
export const BackBtn = ({ onClick, label = 'BACK' }) => (
  <button data-testid="back-btn" onClick={onClick} style={{
    background: 'var(--faint)', border: 'none', color: 'var(--mute)', fontFamily: MONO, fontSize: 11,
    cursor: 'pointer', padding: '14px 20px', marginBottom: 20, letterSpacing: 0.5,
    display: 'flex', alignItems: 'center', gap: 8, minHeight: 48, borderRadius: 8,
  }}>
    <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M19 12H5M12 19l-7-7 7-7" /></svg>
    {label}
  </button>
);
